import { render, staticRenderFns } from "./SuperSearchResultsViewer.vue?vue&type=template&id=7a0d8c76&scoped=true&"
import script from "./SuperSearchResultsViewer.vue?vue&type=script&lang=js&"
export * from "./SuperSearchResultsViewer.vue?vue&type=script&lang=js&"
import style0 from "./SuperSearchResultsViewer.vue?vue&type=style&index=0&id=7a0d8c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d8c76",
  null
  
)

export default component.exports